import { Children, isValidElement, ReactNode } from "react";
import { Option } from "../Option";
import { OptionItem } from "../OptionItem";

/**
 * Gets the options from the specified children.
 * @param children The children to get the options from.
 * @returns The array of options.
 */
export function getOptions(children: ReactNode | undefined): ReadonlyArray<OptionItem> {
  return (
    Children.map(children, (child) => {
      if (!isValidElement(child)) return null;
      if (child.type !== Option) {
        console.log("Dropdown ignoring unsupported child component.");
        return null;
      }
      const { props } = child;
      const { children, label, value } = props;

      let searchText: string | undefined = undefined;
      if (label) searchText = label;
      else if (children && typeof children === "string") searchText = children;

      return { type: "option", label: children ?? label, searchText, value } as OptionItem;
    })?.filter((option) => !!option) ?? []
  );
}
